<template>
  <div class="form-group">
    <label class="mar-lt-15">{{$t('settingCompany.appQRCode')}}</label>
    <template>
      <div class="col-md-12 px-0">
        <img style="height: 170px; width:170px;" v-bind:src="location.app_qr">
      </div>
      <div class="col-md-12 mb-5 ml-4 px-0 mar-to-15">
        <a class="btn btn-info btn-icon duplicate-prod" :href="this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + location.app_qr + '&name=' + 'App ' + location.name + '.png'" target="_blank"><i class="fa fa-download"/></a>
        <button class="btn btn-info btn-icon duplicate-prod" @click.prevent="copy(location.app_link)"><i class="fa fa-copy"/></button>
      </div>
    </template>
  </div>
</template>
<script>
  export default {
    name: 'display-qr-app',
    inheritAttrs: false,
    props: {
      location: Object
    },
    data () {
      return {
        apiUrl: ''
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
    },
    methods: {
      copy (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy).then(function (e) {}, function (e) {})
      }
    }
  }
</script>

<style>
  p {
    overflow: hidden;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .ml-4 {
    margin-left: 1.25rem;
  }
  .px-0 {
    padding-left: 0;
    padding-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/DisplayQrApp.vue